import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
const styles = {
  fontSize: {
    fontSize: '12px',
  },
}

function DisplayButtons(props) {
  return (
    <div>
      <div class=' mb-2'>
        {props.moveFrom != 'notGood' ? (
          <text
            class='chipType mr-2'
            size='sm'
            onClick={() => props.moveArticles(props.moveFrom, 'notGood')}
          >
            Not Good
          </text>
        ) : null}
        {props.moveFrom != 'p0' ? (
          <text
            class='chipType mr-2'
            size='sm'
            onClick={() => props.moveArticles(props.moveFrom, 'p0')}
          >
            P0
          </text>
        ) : null}
        {props.moveFrom != 'p1' ? (
          <text
            class='chipType mr-2'
            size='sm'
            onClick={() => props.moveArticles(props.moveFrom, 'p1')}
          >
            P1
          </text>
        ) : null}
        {props.moveFrom != 'p2' ? (
          <text
            class='chipType mr-2'
            size='sm'
            onClick={() => props.moveArticles(props.moveFrom, 'p2')}
          >
            P2
          </text>
        ) : null}

        <CopyToClipboard text={props.copiedValue} onCopy={() => props.handleCopy()}>
          <text class='chipType mr-2' size='sm'>
            <i class='fas fa-copy' />
          </text>
        </CopyToClipboard>
        {props.moveFrom != 'completed' ? (
          <CopyToClipboard
            text={props.copiedValue}
            onCopy={() => props.handleCopyAndMoveToCompleted(props.moveFrom, 'completed')}
          >
            <text class='chipType mr-2' size='sm'>
              <i class='fas fa-copy' />
              {' + '}
              <i class='fas fa-check' />
            </text>
          </CopyToClipboard>
        ) : null}
      </div>
      {props.copied ? <small style={{ color: 'red' }}>Copied.</small> : null}
    </div>
  )
}

export default DisplayButtons
